import { changePasswordInputType } from "../utils";

const ShowPassword = ({ inputID }) => {
  return (
    <span
      onClick={() => changePasswordInputType(inputID)}
      className="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
    />
  );
};

export default ShowPassword;
